import { AccredibleConfirmDialogComponentModule } from '@accredible-frontend-v2/new-components/dialog';
import { DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  standalone: true,
  imports: [AccredibleConfirmDialogComponentModule, TranslocoModule],
  templateUrl: './confirm-bulk-dialog.component.html',
  styleUrls: ['./confirm-bulk-dialog.component.scss'],
})
export class ConfirmBulkDialogComponent {
  private readonly _dialogRef = inject(DialogRef);

  confirmBulk(): void {
    this._dialogRef.close(true);
  }
}
